import { BehaviorSubject } from 'rxjs';
import { Logger } from '../util/logger';
import { HttpParams } from '@angular/common/http';
import { AppConstants } from './AppConstants';
import * as i0 from "@angular/core";
import * as i1 from "../util/logger";
export class ParamsService {
    constructor(logger) {
        this.logger = logger;
        this.params = new BehaviorSubject(undefined);
    }
    static getParamSync(name) {
        const url = window.location.href;
        let value = null;
        if (url.includes('?')) {
            const params = new HttpParams({ fromString: url.split('?')[1] });
            value = params.get(name);
            value = value && value !== '' && value !== 'null' ? value : null;
        }
        return value;
    }
    /**
     * Gets value of the 'next' parameter by calling getParam.
     * @see getParam
     */
    getNextUrl() {
        return this.getParam(AppConstants.QP_NEXT);
    }
    /**
     * Gets current value of a parameter. This method both updates the params Subject and returns a Promise for the parameter value.
     * @param name Name of the parameter to get.
     * @returns Promise for the parameter value. Null value will be returned for missing value, empty value and 'null' string value.
     */
    getParam(name) {
        const value = ParamsService.getParamSync(name);
        this.updateParam(name, value);
        return new Promise((resolve) => {
            resolve(value);
        });
    }
    /**
     * Updates the params Subject with the given value.
     * @param name Name of the parameter to update.
     * @param value The new parameter value.
     */
    updateParam(name, value) {
        const oldParams = this.params.value;
        const newParams = oldParams ? Object.assign({}, oldParams) : {};
        newParams[name] = value;
        this.params.next(newParams);
    }
}
ParamsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ParamsService_Factory() { return new ParamsService(i0.ɵɵinject(i1.Logger)); }, token: ParamsService, providedIn: "root" });
